"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketLoggingInput_1 = require("./GetBucketLoggingInput");
var GetBucketLoggingOutput_1 = require("./GetBucketLoggingOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketLogging = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketLogging",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?logging"
    },
    input: {
        shape: GetBucketLoggingInput_1.GetBucketLoggingInput
    },
    output: {
        shape: GetBucketLoggingOutput_1.GetBucketLoggingOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketLogging.js.map